<template>
    <DialogueBox :blur="false" :left="58" :top="79" :width="1164" :height="714">

        <div class="greeting-text" v-html="T('before_you_get_started')"></div>
        <div class="facilitator" @click="$emit('toggle-government-cheat')"></div>

        <div class="intro-text">
            <div v-html="text">
            </div>
        </div>

        <div class="shared-back-button-dialogue" v-html="T('button_back')" @click="$emit('back')">
        </div>

        <div class="shared-continue-button-dialogue" @click="$emit('continue-clicked')">
            <div v-html="T('button_continue')"></div>
        </div>

    </DialogueBox>


</template>

<script lang="ts">
import { T } from '@/App.vue';
import Vue, { PropType } from 'vue';
import DialogueBox from "../components/DialogueBox.vue";
import Game from '../../../shared_fca/game';

export default Vue.extend({
    name: 'BeforeYouGetStarted',
    components: {
        DialogueBox,
    },
    props: {
        game: Object as PropType<Game>,
        myUUID: String,
    },
    computed: {

        text: {
            cache: false,
            get(): string {

                if (this.game.governmentSubsidy) {
                    return T("Before_you-get_started_gvt");
                }

                return T("Before_you-get_started_std");

            }
        }


    },
    methods: {

        T(key: string): string {
            return T(key);
        }

    }
});
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.continue-button {
    height: 50px;
    width: 162px;
    border-radius: 8px;
    background-color: #B2CD30;
    color: #ffffff;
    font-family: Rubik;
    font-size: 18px;
    letter-spacing: 0;
    line-height: 22px;
    text-align: center;
    position: absolute;
    margin-top: 15px;
}

.intro-text {
    position: absolute;
    width: 627px;
    top: 158px;
    left: 408px;
    font-family: Rubik;
    font-size: 16px;
    font-weight: 400;
    line-height: 18.96px;
    text-align: left;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
    color: #333333;
}

.greeting-text {
    position: absolute;
    left: 408px;
    top: 102px;
    font-family: Rubik;
    font-size: 30px;
    font-weight: 800;
    line-height: 35.55px;
    text-align: left;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
    color: #636252;
}

.facilitator {
    width: 289px;
    height: 369px;
    top: 173px;
    left: 85px;
    position: absolute;
}
</style>
